const ELLIPSIS = '\u2026';

import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import { QueryDef } from '@services/query-def';
import { CohortService } from '../../services/cohort.service';

@Component({
    selector: 'cohort-select',
    template: `
    <div class="cohort-select">
        <climb-typeahead
            [(model)]="model"
            [resultFormatter]="cohortNameFormatter"
            [keyFormatter]="cohortKeyFormatter"
            [search]="searchCohorts"
            [keySearch]="searchCohortsByKey"  
            [id]="id"
            [disabled]="disabled"
            [placeholder]="placeholder"
            [required]="required"
            [namespace]="'cohort'"
            (selectItem)="selectItemHandler($event)"
            #typeahead
        ></climb-typeahead>
    </div>
    `,
    styles: [`
        .cohort-select {
            min-width: 100px;
        }
    `]
})
export class CohortSelectComponent {
    @Input() model: any;
    @Input() disabled: boolean;
    @Input() id: string;
    @Input() placeholder: string = 'Cohort name' + ELLIPSIS;
    @Input() required: boolean;

    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();


    constructor(
        private cohortService: CohortService
    ) {
        // Nothing to do
    }

    selectItemHandler(item: any) {
        this.modelChange.emit(this.model);
    }


    // Search
    searchCohorts = (search: string): Promise<any[]> => {
        const filter = {
            cohortName: search
        };

        let count = null;
        if (search.length < 3) {
            count = 50;
        }

        return this._searchCohorts(filter, count);
    }

    searchCohortsByKey = (key: any): Promise<any[]> => {
        const filter = {
            C_Cohort_key: key
        };

        return this._searchCohorts(filter, 1);
    }

    private _searchCohorts(filter: any, count: number): Promise<any[]> {
        const queryDef: QueryDef = {
            inlineCount: false,
            page: 1,
            size: count,
            sort: 'CohortName',
            filter
        };

        return this.cohortService.getCohorts(queryDef).then((response: any) => {
            return response.results;
        });
    }


    // Formatters
    cohortNameFormatter = (value: any) => {
        return value.CohortName;
    }

    cohortKeyFormatter = (item: any) => {
        return item.C_Cohort_key;
    }
}
